module.exports = __webpack_public_path__ + "static/media/Chevron.ec9c9534.svg";